import { type ReactNode, useEffect, useMemo, useState } from "react";

import { UiLanguageContext, type UiLanguageContextValue } from "./uiLanguageContext";
import {
  DEFAULT_UI_LANGUAGE,
  uiLanguageOrDefault,
  UI_LANGUAGE_STORAGE_KEY,
  type UiLanguage,
  uiText,
} from "./uiMessages";

function initialUiLanguage(): UiLanguage {
  try {
    return uiLanguageOrDefault(window.localStorage.getItem(UI_LANGUAGE_STORAGE_KEY));
  } catch {
    return DEFAULT_UI_LANGUAGE;
  }
}

export function UiLanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguage] = useState<UiLanguage>(initialUiLanguage);
  useEffect(() => {
    document.documentElement.lang = language;
    try {
      window.localStorage.setItem(UI_LANGUAGE_STORAGE_KEY, language);
    } catch {
      return;
    }
  }, [language]);
  const value = useMemo<UiLanguageContextValue>(
    () => ({
      language,
      setLanguage,
      text: (key, values) => uiText(language, key, values),
    }),
    [language],
  );
  return (
    <UiLanguageContext.Provider value={value}>
      {children}
    </UiLanguageContext.Provider>
  );
}
